import axios from 'axios';
import queryString from 'query-string';
import {X_USER_PARTNER} from 'components/constants';

let CancelToken = axios.CancelToken;
let axiosRequestSignal;
let isAggregatorPartner = false;

export const setPartnerRequestFlag = value => {
    isAggregatorPartner = Boolean(value);
};

const baseURLs = [
    process.env.REACT_APP_INVOICE_API,
    process.env.REACT_APP_WALLET_BASE_URL,
    process.env.REACT_APP_BANK_ACCOUNT_BASE_URL,
    process.env.REACT_APP_PAYMENT_PRO_BASE_URL,
];

const APIs = [];

baseURLs.forEach(url => {
    let API = axios.create({baseURL: url});

    API.interceptors.request.use(config => {
        axiosRequestSignal = CancelToken.source();
        config.cancelToken = axiosRequestSignal.token;

        const headers = {...(config?.headers || {})};

        config.headers = {
            'x-api-key': process.env.REACT_APP_ENVIRONMENT,
            source: 'checkout',
            ...headers,
        };

        const {user} = queryString.parse(window.location.search);
        const isPartnerRequest = user === X_USER_PARTNER || isAggregatorPartner;

        if (isPartnerRequest) {
            config.headers = {...config.headers, 'request-type': X_USER_PARTNER};
        }

        return config;
    });

    API.interceptors.response.use(
        async response => response,
        async error => {
            return Promise.reject(error);
        }
    );

    APIs.push(API);
});

export const requestSignal = axiosRequestSignal;
export const walletAPI = APIs[1];
export const bankAPI = APIs[2];
export const paymentAPI = APIs[3];

export default APIs[1];
